'use client';
import Link from 'next/link';
import './brand.scss';

// The ROffice logo lockup: the real vector R mark + "Office" wordmark in
// Manrope. Replaces every `<img src="/logo.svg">` site (the old logo.svg was a
// non-recolorable embedded PNG). The mark is near-square (viewBox
// 118.845×136.376), so it is sized by height and the wordmark sits beside it in
// a flex row — this component owns the slot geometry so callers just pick a size.

type Size = 'sm' | 'md' | 'lg';

const MARK_HEIGHT: Record<Size, number> = { sm: 26, md: 30, lg: 36 };

interface Props {
  variant?: 'lockup' | 'mark';
  tone?: 'dark' | 'light';
  size?: Size;
  href?: string;
  className?: string;
}

export default function BrandLogo({
  variant = 'lockup',
  tone = 'dark',
  size = 'md',
  href,
  className,
}: Props) {
  const h = MARK_HEIGHT[size];
  const src = tone === 'light' ? '/logo-r-mark-white.svg' : '/logo-r-mark-black.svg';

  const inner = (
    <span
      className={`brand-logo brand-logo--${tone} brand-logo--${size}${className ? ' ' + className : ''}`}
    >
      {/* eslint-disable-next-line @next/next/no-img-element -- small inline brand SVG, not a content image */}
      <img src={src} alt="ROffice" height={h} className="brand-logo__mark" />
      {variant === 'lockup' && <span className="brand-logo__word">Office</span>}
    </span>
  );

  return href ? (
    <Link href={href} className="brand-logo__link" aria-label="ROffice home">
      {inner}
    </Link>
  ) : (
    inner
  );
}
